import {ChangeDetectorRef, Component, effect, input, viewChild, output, inject, ChangeDetectionStrategy} from "@angular/core"
import {MatMenu, MatMenuModule} from "@angular/material/menu"
import {MenuItem} from "@app/common/components/menu/multi-level-menu/menu-item"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-multilevel-menu",
    templateUrl: "./multi-level-menu.component.html",
    styleUrls: ["./multi-level-menu.component.scss"],
    imports: [MatMenuModule],
})
export class MultiLevelMenu {
    readonly $items = input<MenuItem[]>([], {alias: "items"})
    readonly $menuRef = viewChild.required<MatMenu>("menuRef")
    readonly itemClicked = output<MenuItem>()
    private readonly cdr = inject(ChangeDetectorRef)

    constructor() {
        effect(() => {
            this.$items()
            // Explicitly trigger change detection to avoid ExpressionChangedAfterItHasBeenCheckedError after a menu update (caused by menuRef)
            this.cdr.detectChanges()
        })
    }

    onMenuItemClicked(item: MenuItem) {
        this.itemClicked.emit(item)
    }
}
